<template>
  <header
    class="flex items-center w-full px-6 fixed z-20 py-10 border-b lg:border-0 border-opacity-25"
  >
    <div class="flex items-center gap-40">
      <Logo class="h-10 mr-2" />
    </div>
    <SidebarActions />
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getShortAddress } from "@/factories/Utils";
import Logo from "../components/global/Logo.vue";
import SidebarActions from "../components/global/SidebarActions.vue";
export default {
  name: "Header",
  components: {
    Logo,
    SidebarActions,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isConnected"]),
  },
  methods: {
    getShortAddress,
    ...mapActions(["init", "disconnect"]),
  },
};
</script>
